import { render, staticRenderFns } from "./TutorialVisualizador.vue?vue&type=template&id=146b39a3&scoped=true"
import script from "./TutorialVisualizador.vue?vue&type=script&lang=js"
export * from "./TutorialVisualizador.vue?vue&type=script&lang=js"
import style0 from "./TutorialVisualizador.vue?vue&type=style&index=0&id=146b39a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146b39a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VProgressCircular,VSpacer})
